import { messages } from '../store-card-slim-messages';

import { IOrderButtonProps, IOrderButtonTextArgs } from './types';

export const useOrderButtonProps = ({
  defaultClickEventHandler,
  enableOrdering,
}: IOrderButtonTextArgs): IOrderButtonProps => ({
  onOrderClick: defaultClickEventHandler,
  orderButtonText: enableOrdering ? messages.order : messages.select,
});
